/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED UPDATE CTA : STYLES --------------- ++++++++++ */
export default theme => ({
    embedupdatecta: {
        marginTop: pxToEm(20),
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-end',
        '& .ctas': {
            display: 'inline-flex',
            '& .button': {
                height: pxToEm(48),
                width: pxToEm(180),
                marginRight: pxToEm(15),
                '&:last-child': {
                    marginRight: '0'
                }
            }
        }
    },

    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thinnest]: {
        embedupdatecta: {
            justifyContent: 'center',
            '& .ctas': {
                '& .button': {
                    margin: replacePXinStringWithEM('3px 10px !important')
                }
            }
        }
    }
});
